import { SvgIcon } from '@/common/components/SvgIcon'

const PanelButtonPopupIcon = () => <SvgIcon name="browsers" width={14} className="ml-1 text-blue-500 group-hover:text-[#ed2d2d]" />

export default PanelButtonPopupIcon
